import { qriApi } from './index';
import { QriDetailsBulkV2, QriDetailsBulkV2MetadataParser } from '@qualio/search-qri';

const QRI_BATCH_SIZE = 100;

const batchQriDetails = <T>(items: T[], size: number): T[][] => {
  const batches = [];
  for (let i = 0; i < items.length; i += size) {
    batches.push(items.slice(i, i + size));
  }
  return batches;
};

const postDetailsBatch = async (qris: string[]): Promise<QriDetailsBulkV2 | undefined> => {
  const response = await qriApi.post(
    '/v2/details',
    {
      qris,
      short: false,
    },
    {
      params: {
        metadata: true,
      },
    },
  );
  const result = QriDetailsBulkV2MetadataParser.safeParse(response.data);

  if (result.success) {
    return result.data.data.items;
  } else {
    console.log('QRI bulk details response parsing error', result.error);
  }
};

const qriServiceApi = {
  async getBulkDetails(qris: string[]): Promise<QriDetailsBulkV2 | undefined> {
    if (!qris.length) {
      return undefined;
    }
    const batches = await Promise.all(batchQriDetails(qris, QRI_BATCH_SIZE).map(postDetailsBatch));

    return batches.reduce<QriDetailsBulkV2>((acc, batch) => ({ ...acc, ...batch }), {});
  },
};

export default qriServiceApi;
